const initializeAuthUser = async ({ env: { setCurrentUser, user }, oktaAuth }) => {
  if (!user) {
    const currentUser = await oktaAuth.getUser();
    setCurrentUser(currentUser);
  }
};

export default initializeAuthUser;
